export const transformDatesMap: Map<string, (model: any) => void> = new Map();

export function applyTransform(name: string, model: any) {
  if (name.startsWith("Array<")) {
    const realName = name.substring(6, name.length - 1);
    const transformer = transformDatesMap.get(realName);
    if (transformer) {
      if (model.records) {
        model.records.forEach((subModel: any) => {
          transformer(subModel);
        });
      } else {
        model.forEach((subModel: any) => {
          transformer(subModel);
        });
      }
    }
  } else {
    transformDatesMap.get(name)?.call(null, model);
  }
}
